import { render } from "./MigrationsForm.vue?vue&type=template&id=49cc3872&ts=true"
import script from "./MigrationsForm.vue?vue&type=script&lang=ts"
export * from "./MigrationsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__